<template>
    <div class="patients-list">
        <table>
            <thead>
                <tr>
                    <th>
                        #
                    </th>
                    <th>
                        Повне зображення
                    </th>
                    <th>
                        Іконка
                    </th>
                    <th>
                        Стать
                    </th>
                    <th>
                        Вік
                    </th>
                    <th>
                        Дія
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(p, index) in patients" :key="index">
                    <td>
                        {{index + 1}}
                    </td>
                    <td>
                        <img :src="`${publicPath}` + p.image" class="image full">
                    </td>
                    <td>
                        <img :src="`${publicPath}` + p.shortImage" class="image short">
                    </td>
                    <td>
                        {{p.isMale ? 'Чоловіча' : 'Жіноча'}}
                    </td>
                    <td>
                        {{p.ageRange}}
                    </td>
                    <td>
                        <button type="button" class="remove" @click="removePatientImages(p.id)">Видалити</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data : () => ({
        patients : [],
        publicPath: process.env.BASE_URL
    }),
    mounted(){
        axios.interceptors.request.use((config) => {
            var token = sessionStorage.getItem('access_token');
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        });

        axios.get(location.protocol + '/api/Admin/GetPatientsImages')
        .then(response => {
            this.patients = response.data;            
        })
    },
    methods : {
        getCorrectPath(str){
            str = str.replace(/\\/g, '/');
            return str;
        },
        removePatientImages(id){
            axios.interceptors.request.use((config) => {
                var token = sessionStorage.getItem('access_token');
                config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            });

            axios.delete(location.protocol + '/api/Admin/RemovePatientsImages/' + id)
            .then(response => {
                console.log(response);
                let patientImgForDel = this.patients.filter(pObj => {
                    return pObj.id == id;
                });

                let index = this.patients.indexOf(patientImgForDel);
                this.patients.splice(index, 1);
            })
        }
    }
}
</script>

<style lang="scss">
@import '../../../assets/style/table.scss';

.patients-list{
    padding: 40px 60px;
}

.image{
    &.full{
        max-width: 100px;
        height: auto;
    }

    &.short{
        max-width: 80px;
        height: auto;
    }
}
</style>